// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","choose-new-password__link":"choose-new-password_choose-new-password__link__xg7fc"};